import { render } from "./AccountNavbar.vue?vue&type=template&id=0af3b84e&scoped=true"
import script from "./AccountNavbar.vue?vue&type=script&lang=js"
export * from "./AccountNavbar.vue?vue&type=script&lang=js"

import "./AccountNavbar.vue?vue&type=style&index=0&id=0af3b84e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af3b84e"]])

export default __exports__